
  
  import { ModelSelect, ModelListSelect  } from 'vue-search-select'
  import 'vue-search-select/dist/VueSearchSelect.css'
  
  
  import UMUM from '../../library/umum'
  import DATA_MASTER from '../../library/dataMaster'
  import FETCHING from '../../library/fetching'
  
  
  import Joi from "joi";
  
  const schema = Joi.object().keys({
      username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
      password: Joi.string().min(6).required(),
    });
  
  
  
  export default {
    components: {
        ModelSelect, ModelListSelect, 
    },
  
    data() {
      return {
        
        status: '',
        form : {
        
          uraian : '',
          keterangan : '',
          unit_kerja : '',
        },
  
         lampiran : {
            id : '',
            direktori_id : '',
            unit_kerja_id : '',
            master_type_id : 1,
            uraian : '',
            keterangan : '',
            file : null,
            file_type : '',
            status : 0,
            notice : '',
             file_old : null,
          },
  
          folder : {
            id : '',
            status : 0,
            notice : '',
          },
  
          tanggapan : {
            id : '',
            penyesuaian_absensi_id : '',
            nip : '',
            uraian : '',
            keterangan : '',
            file : null,
            file_type : '',
          },
  
          dataku: {
              id : '',
              username : "",
              hp: "",
              email: "",
              nip : '',
              password : "",
              confirmPassword: "",
              menu_klp : 0,
              unit_kerja : '',
              metode_absen : 1,
          },
  
  
        filterku : {
          instansi : '',
          unit_kerja : '',
          fileStat : false,
        },
       
      
        list_data : [],
        list_klp : [],
        lokasi : [],
        checkAll : true,
  
        errorMessage: '',
        signingUp : false,
      
        UMUM : UMUM,
        DATA_MASTER : DATA_MASTER,
        FETCHING : FETCHING,
  
        nm_jabatan : '',
        nm_unit_kerja : '',
  
        instansi_id : '',
        unit_kerja : '',
        unit_kerja_full : '',
        unit_kerja_edit : '',
  
        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
  
        cek_load_data : true,
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_add_file : false,
        
        mdl_lihat : false,
        mdl_list : false,
        mdl_open : false,
        mdl_keterangan_folder :false,
        mdl_keterangan :false,
        mdl_list_direktori: false,
        mdl_kembalikan_folder :false,
        mdl_kembalikan :false,
        mdl_approve_folder :false,
        mdl_approve :false,
        mdl_list_hasil :false,
        mdl_delete_tanggapan : false,
        mdl_add_tanggapan : false,
        mdl_open_tanggapan : false,
        mdl_edit_tanggapan : false,
  
  
        mdl_unit : false,
  
        file_path: this.$store.state.url.URL_APP + "uploads/",
  
  
  
  
  
        nama_keterangan: "",
  
  
  
        cariNamaPegawai : '',
        list_penyesuaian_absensi_asn : [],
        list_lampiran : [],
        list_direktori_asn:[],
        list_hasil:[],
      }
    },
    methods: {
  
  
      getView : function(){
        this.cek_load_data = true;
        fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "view", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                  data_ke: this.page_first,
                  cari_value: this.cari_value,
                  page_limit : this.page_limit,
                  // unit_kerja : this.unit_kerja_id,
               
                  status : this.status,
                unit_kerja : this.filterku.unit_kerja,
                instansi : this.filterku.instansi,
                penyesuaian_absensi_id : this.id_penyesuaian_absensi,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
                console.log(this.list_data + "siap");
        });
      },
  
      getView1 : function(a){
        fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "view1", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id_penyesuaian_absensi : a,
            })
        })
            .then(res => res.json())
            .then(res_data => {
              this.list_penyesuaian_absensi_asn = res_data;
  
              this.uraian = this.list_penyesuaian_absensi_asn[0].uraian;
              this.total_file = this.list_penyesuaian_absensi_asn.map(total => total.proses).reduce((acc, amount) => acc + amount);
              this.nama_keterangan = this.list_penyesuaian_absensi_asn[0].keterangan;
              
        });
      },
  
      getTanggapan : function(penyesuaian_absensi, nip){
     
        fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "hasil", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                penyesuaian_absensi_id : penyesuaian_absensi,
                nip : nip,
  
            })
        })
            .then(res => res.json())
            .then(res_data => {
              console.log("AAAAAAAAAAAA " + res_data.data)
              this.list_hasil = res_data.data;
        });
      },
  
      addTanggapan: function(){
   
          // var get_profile = JSON.parse(localStorage.profile);
          // this.hasilaudit.unit_kerja_id = get_profile.profile.unit_kerja; 
  
          var formData = new FormData();
          formData.append('pbx', JSON.stringify(this.tanggapan));
          formData.append('file', this.tanggapan.file);
  
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + 'addDatax', {
              method: "POST",
              headers: {
                  authorization: "kikensbatara " + localStorage.token
              },
              body: formData
              }).then(res_data => {
                
                  var a = this.tanggapan.penyesuaian_absensi_id
                  var b = this.tanggapan.nip

                  this.getTanggapan(a, b); 
                  this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
          });
          },
  
  
      selectData : function(data){
          // console.log(data)
          this.form.id = data.id;
          this.form.uraian = data.uraian;
          this.form.keterangan = data.keterangan;
          this.form.unit_kerja = data.unit_kerja;
          this.lampiran.penyesuaian_absensi_id = data.id;
          this.lampiran.unit_kerja_id = data.unit_kerja_id;
  
          this.getLampiran();
  
      
      },
  
      select2(data){
          this.lampiran.penyesuaian_absensi_id = data.id
          this.lampiran.nip = data.nip
          this.lampiran.unit_kerja_id = data.unit_kerja_id
  
          this.getLampiran(data.id_penyesuaian_absensi, data.nip);
          
          // this.getTanggapan(data.id, data.id_instansi) 
          
        },
  
  
        selectLampiran : function(data){
          // console.log(data.file + "asubabi");
          
          this.lampiran.id = data.id;
          this.lampiran.penyesuaian_absensi_id = data.penyesuaian_absensi_id;
          this.lampiran.nip = data.nip;
          this.lampiran.unit_kerja_id = data.unit_kerja_id;
          this.lampiran.uraian = data.uraian;
          this.lampiran.keterangan = data.keterangan;
          this.lampiran.status = data.status;
          this.lampiran.notice = data.notice;
          this.lampiran.file_old =  data.file
          this.lampiran.file = this.lampiran.file
  
          this.tanggapan.nip= data.nip
          this.tanggapan.penyesuaian_absensi_id = data.id_penyesuaian_absensi
          this.tanggapan.id = data.id;
          this.tanggapan.uraian = data.uraian;
          this.tanggapan.keterangan = data.keterangan;
          this.tanggapan.file_old =  data.file
          this.tanggapan.file = this.tanggapan.file
  
          this.getLampiran(data.id_penyesuaian_absensi, data.nip);
          this.getTanggapan(data.id_penyesuaian_absensi, data.nip)
  
          // this.form.unit_kerja_id = data.unit_kerja_id;
          },
  
          selectFileLampiran : function(data){ 
           this.lampiran.id = data.id;
            this.lampiran.penyesuaian_absensi_id = data.penyesuaian_absensi_id;
            this.lampiran.nip = data.nip;
            this.lampiran.uraian = data.uraian;
            this.lampiran.keterangan = data.keterangan;
            this.lampiran.status = data.status;
            this.lampiran.notice = data.notice;
          this.lampiran.file_old =  data.file
          
          this.lampiran.file = this.lampiran.file
  
          console.log(data); 
  
        },
  
        selectFolder : function(data){ 
           this.folder.id = data.id;
            this.folder.status = data.status;
            this.folder.notice = data.notice;
  
        },
  
        selectTanggapan : function(data){
  
          this.tanggapan.id = data.id;
          this.tanggapan.penyesuaian_absensi_id = data.id_penyesuaian_absensi
          this.tanggapan.nip = data.nip;
          this.tanggapan.uraian = data.uraian;
          this.tanggapan.keterangan = data.keterangan;
          this.tanggapan.file_old =  data.file;
          this.tanggapan.file = this.tanggapan.file
          },
  
        approveFolder: async function(){
          // await UMUM.notifApprove();
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + 'approveFolder', {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.folder)
              }).then(res_data => {
                this.getView1(this.form.id);
                this.Notify ('Mempublish', 'primary', 'check_circle_outline');
          });
        },
        approve: async function(){
          // await UMUM.notifApprove();
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + 'approve', {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.lampiran)
              }).then(res_data => {
                this.getLampiran(this.tanggapan.penyesuaian_absensi_id, this.tanggapan.nip);
                this.Notify ('Mempublish', 'primary', 'check_circle_outline');
          });
        },
  
        evaluasiFolder: async function(){
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + 'kembalikanFolder', {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.folder)
              }).then(res_data => {
                this.getView1(this.form.id);
                this.mdl_kembalikan_folder = false;
                this.Notify ('Mengevaluasi', 'primary', 'check_circle_outline');
          });
        },
        evaluasi: async function(){
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + 'kembalikan', {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.lampiran)
              }).then(res_data => {
                this.getLampiran(this.tanggapan.penyesuaian_absensi_id, this.tanggapan.nip);
                this.mdl_kembalikan = false;
                this.Notify ('Mengevaluasi', 'primary', 'check_circle_outline');
          });
        },
  
  
        getLampiran : function(penyesuaian_absensi){
  
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "viewLampiran", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  penyesuaian_absensi_id : penyesuaian_absensi,
                  unit_kerja_id :  this.lampiran.unit_kerja_id,
                  nip : this.lampiran.nip,
              })
          })
              .then(res => res.json())
              .then(res_data => {
                console.log(res_data)
                this.list_lampiran = res_data
          });
        },
  
        async getView1 (b){
  
        this.list_direktori_asn = await FETCHING.FETCH_POST(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "view2", 
          {id_penyesuaian_absensi : b}
        )
  
        },
  
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
  
          indexing : function(index){
              var idx = ((this.page_first-1)*this.page_limit)+index
              return idx;
          },
  
  
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
          selectBiodata (item) {
            return `${item.nama} | NIP. ${item.nip}`
          },
  
  
          getAsyncPost : async function() {
            this.list_klp = await FETCHING.postMasterKlpMenu();
          },
  
          // cariNama : async function(){
          //   this.$store.state.list_biodata = await FETCHING.FETCH_POST(this.$store.state.url.URL_simpeg_biodata + "list", {cari : this.cariNamaPegawai})
          // },
  
      // ====================================== PAGINATE ====================================
    },
  
    mounted () {
  
      var get_profile = JSON.parse(localStorage.profile);
      this.filterku.unit_kerja = get_profile.profile.unit_kerja;
      this.filterku.instansi = get_profile.profile.instansi_id;
      this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
      this.unit_kerja = get_profile.profile.unit_kerja;
      this.form.unit_kerja = get_profile.profile.unit_kerja;
      this.status = get_profile.profile.penyesuaian_absensi;
  
      this.dataku.unit_kerja = get_profile.profile.unit_kerja;
  
      DATA_MASTER.getInstansi();
      DATA_MASTER.getUnitKerja(this.filterku.instansi);
      DATA_MASTER.getBiodata(this.dataku.unit_kerja);
      
      this.getAsyncPost()
  
      this.getView();
  
      // this.cariNama();
  
  
    },
  }
  